var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.markdownFieldClass },
    [
      _vm.label && !_vm.hideInlineEditor
        ? _c("div", { staticClass: "az-text-label" }, [
            _vm._v(_vm._s(_vm.label))
          ])
        : _vm._e(),
      _vm.isToolbarVisible && !_vm.hideInlineEditor
        ? _c(
            "div",
            { staticClass: "aawz-markdown-field__toolbar" },
            [
              _c("MarkdownFieldWidgets", {
                attrs: {
                  "can-edit": _vm.canEdit,
                  "table-picker": _vm.tablePicker,
                  "table-picker-label": _vm.tablePickerLabel,
                  "menu-value": _vm.tablePicker.openMain
                },
                on: {
                  "toolbar-action": _vm.onToolbarAction,
                  "table-open": function($event) {
                    _vm.tablePicker.openMain = $event
                  },
                  "table-hover": _vm.setTablePickerHover,
                  "table-clear": _vm.clearTablePickerHover,
                  "table-apply": _vm.applyTableFromPicker
                }
              }),
              _c(
                "div",
                { staticClass: "d-flex align-center az-gap-xsmall" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-icon-square is-active",
                      attrs: {
                        icon: "",
                        "x-small": "",
                        disabled: !_vm.canEdit,
                        title: "Opções de formatação"
                      },
                      on: {
                        mousedown: function($event) {
                          $event.preventDefault()
                        },
                        click: _vm.toggleToolbar
                      }
                    },
                    [
                      _c("icon-svg", {
                        attrs: { name: "text-formatter", size: "18" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-icon-square",
                      attrs: {
                        icon: "",
                        "x-small": "",
                        disabled: !_vm.canEdit,
                        title: "Expandir editor"
                      },
                      on: {
                        mousedown: function($event) {
                          $event.preventDefault()
                        },
                        click: _vm.openExpanded
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-fullscreen")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.hideInlineEditor
        ? _c(
            "div",
            { staticClass: "aawz-markdown-field__editor-wrapper" },
            [
              !_vm.isToolbarVisible
                ? _c(
                    "v-btn",
                    {
                      staticClass:
                        "btn-icon-square aawz-markdown-field__toolbar-toggle--floating",
                      attrs: {
                        icon: "",
                        "x-small": "",
                        disabled: !_vm.canEdit,
                        title: "Opções de formatação"
                      },
                      on: {
                        mousedown: function($event) {
                          $event.preventDefault()
                        },
                        click: _vm.toggleToolbar
                      }
                    },
                    [
                      _c("icon-svg", {
                        attrs: { name: "text-formatter", size: "18" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isToolbarVisible
                ? _c(
                    "v-btn",
                    {
                      staticClass:
                        "btn-icon-square aawz-markdown-field__toolbar-toggle--expand",
                      attrs: {
                        icon: "",
                        "x-small": "",
                        disabled: !_vm.canEdit,
                        title: "Expandir editor"
                      },
                      on: {
                        mousedown: function($event) {
                          $event.preventDefault()
                        },
                        click: _vm.openExpanded
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-fullscreen")])],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                _vm._b(
                  {
                    ref: "editor",
                    staticClass: "aawz-markdown-field__editor new-ux-scroll",
                    class: _vm.editorClass,
                    style: _vm.editorStyle,
                    attrs: {
                      contenteditable: _vm.canEdit,
                      "data-placeholder": _vm.placeholder,
                      "aria-disabled": !_vm.canEdit
                    },
                    on: {
                      input: _vm.onInput,
                      focus: _vm.onFocus,
                      blur: _vm.onBlur,
                      mouseup: _vm.onSelectionChange,
                      keyup: _vm.onSelectionChange,
                      paste: _vm.onPaste
                    }
                  },
                  "div",
                  _vm.$attrs,
                  false
                )
              ),
              _vm.$slots.footer
                ? _c(
                    "div",
                    { staticClass: "aawz-markdown-field__footer" },
                    [_vm._t("footer")],
                    2
                  )
                : _vm._e(),
              _c("v-slide-y-transition", [
                _vm.hasError
                  ? _c("div", { staticClass: "aawz-markdown-field__error" }, [
                      _vm._v(" " + _vm._s(_vm.errorMessages[0]) + " ")
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "MarkdownFieldDialog",
        _vm._b(
          {
            ref: "expandedDialog",
            attrs: {
              "can-edit": _vm.canEdit,
              "preview-only": _vm.previewOnly,
              "table-picker": _vm.tablePicker,
              "table-picker-label": _vm.tablePickerLabel,
              placeholder: _vm.placeholder,
              "is-empty": !_vm.expandedValue,
              "preview-value": _vm.expandedValue
            },
            on: {
              "toolbar-action": _vm.onToolbarAction,
              "table-open-expanded": function($event) {
                _vm.tablePicker.openExpanded = $event
              },
              "table-hover": _vm.setTablePickerHover,
              "table-clear": _vm.clearTablePickerHover,
              "table-apply": _vm.applyTableFromPicker,
              "editor-input": _vm.onInput,
              "editor-focus": _vm.onFocus,
              "editor-blur": _vm.onBlur,
              "editor-mouseup": _vm.onSelectionChange,
              "editor-keyup": _vm.onSelectionChange,
              "editor-paste": _vm.onPaste,
              close: _vm.closeExpanded,
              save: _vm.handleDialogSave
            },
            model: {
              value: _vm.isExpanded,
              callback: function($$v) {
                _vm.isExpanded = $$v
              },
              expression: "isExpanded"
            }
          },
          "MarkdownFieldDialog",
          _vm.$attrs,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }